// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared'

const LoadingDotsAnimation = (props: {
  color: string,
  translucentColor: string
}): React.Node => {
  return (
    <DotsContainer
      color={props.color}
      translucentColor={props.translucentColor}
    >
      <div className='dot-flashing'></div>
    </DotsContainer>
  )
}

export default LoadingDotsAnimation

const DotsContainer = styled.div`
  display: flex;
  justify-content: center;

  .dot-flashing {
    animation: dot-flashing 1s infinite linear alternate;
    animation-delay: 0.3s;
    background-color: ${(props: { color: string }): string =>
    props.color || colors.sand};
    border-radius: 5px;
    color: ${(props: { color: string }): string => props.color || colors.sand};
    height: 10px;
    position: relative;
    width: 10px;
  }
  .dot-flashing::before,
  .dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }
  .dot-flashing::before {
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 0s;
    background-color: ${(props: { color: string }): string =>
    props.color || colors.sand};
    border-radius: 5px;
    color: ${(props: { color: string }): string => props.color || colors.sand};
    height: 10px;
    left: -15px;
    width: 10px;
  }
  .dot-flashing::after {
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 0.8s;
    background-color: ${(props: { color: string }): string =>
    props.color || colors.sand};
    border-radius: 5px;
    color: ${(props: { color: string }): string => props.color || colors.sand};
    height: 10px;
    left: 15px;
    width: 10px;
  }

  @keyframes dot-flashing {
    0% {
      background-color: ${(props: { color: string }): string =>
    props.color || colors.sand};
    }
    50%,
    100% {
      background-color: ${(props: { translucentColor: string }): string =>
    props.translucentColor || colors.sand20};
    }
  }
`
